import { ONBOARDING_INITIAL_STEP } from 'constants/onboarding'

/**
 * Medleve ORGANIC homepage (medleve.com `/`) — isolated tree.
 *
 * Nothing in `modules/landings/MedLeveHome` may be imported by the paid/campaign routes
 * (`/gads*`, `/meta`, `/medleve`, `/campanha-*`): those keep rendering `MedLevePage` untouched.
 */

/**
 * Go-live switch of the organic homepage. While `false`, `/` on the Medleve host keeps rendering the
 * current landing (`MedLevePage`) exactly as before, and the organic homepage is reachable only at
 * `HOME_PREVIEW_PATH` (noindex) for stakeholder review. Flip to `true` to launch it on `/`.
 */
export const MEDLEVE_ORGANIC_HOME_LIVE: boolean = true

/** Review-only URL of the organic homepage (Medleve host only, `noindex, nofollow`, not in the sitemap). */
export const HOME_PREVIEW_PATH = '/medleve-preview/home'

/** Same DOM id the paid landing uses for its hero (`HERO_SECTION_ID`), kept so id-based behaviour is unchanged. */
export const HOME_HERO_ID = 'hero-section'

/** PRD §8 — the CTA label never changes. */
export const HOME_CTA_LABEL = 'Começar'

/** Same destination as every CTA of the current Medleve landing (start of the weight-loss onboarding). */
export const HOME_CTA_HREF = `/onboarding/weight_loss/${ONBOARDING_INITIAL_STEP}`

/** WhatsApp community link of the current Medleve header, query string included. */
export const HOME_COMMUNITY_URL = 'https://chat.whatsapp.com/DYNysh1leF2HL0aXAPSmU2?s=cl&p=i&mlu=4&ilr=4'

/**
 * Meta (Facebook) domain-verification token: the SAME value `components/meta/CharlesMeta.tsx` emits on
 * every page that uses it (the previous Medleve homepage included). Never change it here alone.
 */
export const HOME_FACEBOOK_DOMAIN_VERIFICATION = '5tv92hyat43umk69220bunz3mbuzpx'

/** In-page anchor of the "Sobre a Medleve" section (footer link). */
export const HOME_ABOUT_ID = 'sobre'
